import _ from 'lodash';
import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { first } from 'rxjs/operators';
import {FaqSchema} from '../../../../campaign/structure/event-page';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { QuillCustomComponent } from '../../quill-custom/quill-custom.component';

@Component({
  standalone:true,
  imports:[CommonModule,FormsModule,ReactiveFormsModule,MdbFormsModule,QuillCustomComponent],
  selector: 'app-faq-info',
  templateUrl: './faq-info.component.html',
  styleUrls: ['./faq-info.component.scss']
})
export class FaqInfoComponent implements OnInit, OnDestroy {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public option: UntypedFormGroup = null;
  public questionControl: UntypedFormControl = null;
  public answerControl: UntypedFormControl = null;


  constructor(
    private store: Store,
    private formBuilder: UntypedFormBuilder,
    private campaignService: CampaignService,
    private dialogService: DialogService,
  ) {
    this.option = this.formBuilder.group({});
    this.campaignService.generateForm(this.option, FaqSchema);

    this.dialog$.pipe(
      first(),
      takeUntilDestroyed()
    ).subscribe(({ initialState }) => {
      const option = _.get(initialState, 'option', null);
      if(option) {
        this.campaignService.initializeForm(this.option, option, FaqSchema);
      }
    });
  }

  ngOnInit(): void {
    this.questionControl = this.option.get('question') as UntypedFormControl;
    this.answerControl = this.option.get('answer') as UntypedFormControl;
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  close(dialog, value) {
    const { initialState: { id, action } } = dialog;
    this.dialogService.closeDialogSubject.next({ id, action, name: 'faqInfo', value });
  }

  confirm(dialog, value) {
    if (this.option.invalid) {
      return this.option.markAllAsTouched();
    }
    return this.close(dialog, value);
  }

}
